"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefinementHeader = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var filter_input_1 = require("../../FilterInput/filter_input");
var styled_search_input_1 = require("../../SearchInput/styled_search_input");
var RefinementContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Refinement = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
var RefinementHeader = function (props) {
    var filters = props.filters, setFilters = props.setFilters, setSearch = props.setSearch, searchPlaceholder = props.searchPlaceholder, filtersLabel = props.filtersLabel, applyLabel = props.applyLabel, removeLabel = props.removeLabel, cancelLabel = props.cancelLabel;
    var _a = (0, react_1.useState)(''), search = _a[0], setSearchInner = _a[1];
    var onUpdateSearch = function (newSearch) {
        setSearchInner(newSearch);
        setSearch(newSearch);
    };
    var onAppliedFilters = function (value, selected) {
        setFilters(function (prev) {
            return prev.map(function (filter) {
                if (filter.value === value) {
                    filter.selected = selected;
                }
                return filter;
            });
        });
    };
    return (react_1.default.createElement(RefinementContainer, null,
        react_1.default.createElement(Refinement, null,
            react_1.default.createElement(styled_search_input_1.StyledSearchInput, { updateSearchQuery: onUpdateSearch, searchQuery: search, placeholder: searchPlaceholder })),
        react_1.default.createElement(Refinement, null,
            react_1.default.createElement(filter_input_1.FilterInput, { filtersLabel: filtersLabel, applyLabel: applyLabel, removeLabel: removeLabel, cancelLabel: cancelLabel, filters: filters, setAppliedFilters: onAppliedFilters }))));
};
exports.RefinementHeader = RefinementHeader;
var templateObject_1, templateObject_2;
